import validateFilterQuery from './validator';
import { formatValidationError, tryParse } from '../utils';
export function decodeFilterQuery(value) {
    var jsonValue = tryParse(value);
    if (!validateFilterQuery(jsonValue)) {
        throw Error(formatValidationError('validateFilterQuery', validateFilterQuery.errors, jsonValue));
    }
    return jsonValue;
}
export function tryDecodeFilterQuery(value) {
    try {
        return decodeFilterQuery(value);
    }
    catch (err) {
        return null;
    }
}
